const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  disabled = false, 
  className = '',
  type = 'button',
  ...props 
}) => {
  const baseStyles = 'px-4 py-1.5 text-sm font-light rounded-sm transition-colors focus:outline-none focus:ring-1 focus:ring-offset-0';
  
  const variants = {
    primary: 'bg-black text-white hover:bg-gray-800 focus:ring-gray-400 disabled:bg-gray-300 disabled:cursor-not-allowed',
    secondary: 'bg-white text-gray-900 border border-gray-300 hover:bg-gray-50 focus:ring-gray-400 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed',
    danger: 'bg-black text-white hover:bg-gray-800 focus:ring-gray-400 disabled:bg-gray-300 disabled:cursor-not-allowed',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

